import { useMiniappSdk } from 'components/miniapp-sdk-provider/miniapp-sdk.hook';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { push, goBack } from 'store/router/actions';
import { HEADER_BUTTON_MODE } from '@hqo/hqo-miniapp-client-sdk';

interface UseModalNavigationReturnValues {
  handleCloseModal: VoidFunction;
  handleOpenModal: VoidFunction;
}

export const useCheckoutModalNavigation = (): UseModalNavigationReturnValues => {
  const dispatch = useDispatch();
  const isMobile = useIsSmallViewportWidth();
  const client = useMiniappSdk();
  const { search, pathname } = useLocation();

  const handleCloseModal = useCallback(() => {
    dispatch(goBack());
  }, [dispatch]);

  const handleOpenModal = useCallback(() => {
    if (isMobile) {
      client.header.setHeader('', HEADER_BUTTON_MODE.HISTORY);
      client.header.showHeader();
      dispatch(push(`${pathname}/terms-and-conditions${search}`));
    } else {
      dispatch(push(`${pathname}/terms-and-conditions${search}`));
    }
  }, [dispatch, pathname, search, isMobile, client]);

  return { handleCloseModal, handleOpenModal };
};
